<template>
    <div>
        <BookingBack title='Order Booking' :textColor="'#333333'" :isCenter="true"/>
        <div ref="dateSection">
            <BookingDateSection
                :dates="bookingDates"
                :selected-date="selectedDate"
                @select="handleDateChange"
            />
        </div>
        <div class="serviceList">
            <div class="serviceRow" v-for="(item,index) in serviceData" :key="index" >
                <div class="serviceItem">
                    <div class="serviceTop">
                        <div>
                            <div class="serviceName">{{ item.name }}</div>
                            <div class="serviceDuration">{{ formatServiceDuration(item) }}</div>
                        </div>
                        <div class="serviceRight">
                            <img class="close" src="@/assets/booking/close.png" alt="" @click="handleRemove(index)">
                            <div class="price">${{ item.price }}</div>
                        </div>
                    </div>

                </div>
                <div class="line"></div>
                <div class="serviceBottom">
                   <div class="serviceInfo">
                        <div class="staff">Staff:</div>
                        <img v-if="item.technician" class="avatar" :src="getUrl(item.technician.image.file_path)" alt="">
                        <div v-else class="any-avatar">Any</div>
                        <div class="name">{{ item.technician ? item.technician.name : 'Any Specialist' }}</div>
                   </div>
                   <div class="chooseServiceBtn" @click="handleChoosePeople(index,item)">Change</div>
                </div>
            </div>
        </div>
        <div style="width:100%;padding:0 1rem;box-sizing: border-box;">
            <div class="addBtn" @click="handleOpenShop">+ Add another service</div>
        </div>
        <BookingTimeSection
            :slots="calendarSlots"
            :selected-slot-start="selectedSlot ? selectedSlot.start_time : null"
            :loading="calendarLoading"
            :error="calendarError"
            :closed="calendarClosed"
            :has-available-slots="hasAvailableSlots"
            :can-use-any="canUseAnySpecialist"
            :fallback-service-name="fallbackServiceName"
            @select-time="selectCalendarSlot"
            @choose-date="handleChooseAnotherDate"
            @use-any="handleUseAnySpecialist"
        />
        <div class="bookingBox">
            <div class="bookingItem">
                <div>${{ totalPrice.toFixed(2) }}</div>
                <button type="button" class="bookingBtn" :disabled="!canBook" @click="handleGoPay">Book</button>
            </div>
        </div>
        <!-- 选择日期 -->
        <!-- Select Staff -->
        <van-popup
            v-model="showPeople"
            closeable
            round
            close-icon-position="top-right"
            position="bottom"
            :style="{ height: '50%',padding:'1rem',boxSizing: 'border-box' }"
        >
        <div>Select Staff</div>
        <div class="peopleList">
            <div class="peopleItem" @click="handleAnySpecialist()">
                <div class="any-avatar-lg">Any</div>
                <div class="">
                    <div class="name">Any Specialist</div>
                    <div class="status">Automatically assign upon arrival</div>
                </div>
            </div>
            <van-divider />
            <div  v-for="item in peopleList">
                <div class="peopleItem" @click="handlePeople(item)">
                    <van-image
                        class="avtar"
                        :src="getUrl(item.image.file_path)"
                    />
                    <div class="">
                        <div class="name">{{ item.name }}</div>
                        <div class="status">{{ item.remark }}</div>
                    </div>
                </div>
                <van-divider />
            </div>
             <van-empty v-if="peopleList.length == 0" description="No staff available for this time slot" />
        </div>
        </van-popup>
        <!-- 选择店铺 -->
        <van-popup
            v-model="showShop"
            closeable
            round
            close-icon-position="top-right"
            position="bottom"
            :style="{ height: '90%',padding:'1rem',boxSizing: 'border-box' }"
        >
            <div>Add Service</div>
            <div class="searchData" v-if="shopDetail != null">
                <div class="shopInfo">
                    <div>{{ shopDetail.name }}</div>
                    <div class="address">{{ shopDetail.address }}</div>
                </div>
                <div class="scoreInfo">
                    <div class="scoreInfo">{{ shopDetail.score }}</div>
                    <div style="margin-top:0.25rem">
                        <ShopStar :num="Number(shopDetail.score)"/>
                    </div>
                </div>
            </div>
            <ShopService v-if="shopDetail != null" :data="shopDetail.service || {}" :isPopup="true"/>
        </van-popup>
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin'
import { Dialog, Notify, Toast } from 'vant'
import BookingBack from '@/components/Booking/back.vue'
import ShopService from '@/views/shop/service.vue'
import ShopStar from '@/components/Shop/ShopStar.vue'
import BookingDateSection from '@/components/BookingCalendar/DateSection.vue'
import BookingTimeSection from '@/components/BookingCalendar/TimeSection.vue'
export default {
    name:'Booking',
    mixins: [myMixin],
    data(){
        return {
            totalPrice:0,
            serviceData:[
            ],
            peopleList:[
            ],
            technicianOptions:{},
            shopDetail:null,
            shopSupplierId:null,
            appId:10001,
            activeRowIndex:0,
            showPeople:false,
            showShop:false,
            bookingDates:[],
            selectedDate:'',
            calendarSlots:[],
            selectedSlot:null,
            calendarLoading:true,
            calendarError:'',
            calendarClosed:false,
            calendarRequestId:0,
            lastChangedServiceIndex:null,
        }
    },
    components:{
        BookingBack,
        ShopService,
        ShopStar,
        BookingDateSection,
        BookingTimeSection
    },
    created(){
        // this.getSupplierDetail()
    },
    computed:{
        merchantTimezone(){
            return (this.shopDetail && this.shopDetail.timezone) || 'America/Chicago'
        },
        hasAvailableSlots(){
            return this.calendarSlots.some(slot=>slot.available)
        },
        canBook(){
            return this.serviceData.length > 0 && this.serviceData.every(item=>item.start_time && item.end_time)
        },
        fallbackServiceIndex(){
            const index = this.lastChangedServiceIndex
            if(index === null || !this.serviceData[index]) return -1
            const item = this.serviceData[index]
            const technicianId = item.technician ? Number(item.technician.id) : Number(item.technician_id || 0)
            return technicianId > 0 ? index : -1
        },
        canUseAnySpecialist(){
            return this.fallbackServiceIndex >= 0
        },
        fallbackServiceName(){
            const item = this.serviceData[this.fallbackServiceIndex]
            return item ? item.name : ''
        }
    },
    watch:{
        serviceData: {
            handler(newVal, oldVal) {
                this.totalPrice = 0
                for(let i in newVal ){
                    this.totalPrice += Number(newVal[i].price)
                }
            },
            deep: true, // 深度监听
            // immediate: true // 初始化时立即执行一次
        },
    },
    async mounted(){
        this.$api.getUserDetail().catch(() => {})
        let restored = null
        if(this.$route.query.restore === '1'){
            try{
                restored = JSON.parse(sessionStorage.getItem('hwm_booking_calendar_draft') || 'null')
            }catch(error){
                restored = null
            }
        }

        if(restored && Array.isArray(restored.serviceData)){
            this.serviceData = restored.serviceData
            this.shopSupplierId = restored.shopSupplierId || null
            this.appId = restored.appId || 10001
            this.selectedDate = restored.selectedDate || ''
            this.clearBookingTimes()
        }else{
            let data = {}
            try{
                data = JSON.parse(this.$route.query.data || '{}') || {}
            }catch(error){
                data = {}
            }
            if(data && Object.keys(data).length > 0){
                this.serviceData.push(data)
            }
            this.shopSupplierId = data.shop_supplier_id || this.$route.query.shop_supplier_id || null
            this.appId = data.app_id || this.$route.query.app_id || 10001
        }

        await this.getSupplierDetail()
        this.buildBookingDates()
        await this.loadTechnicianOptions()
        await this.refreshCalendar()
        this.$bus.$on('closePopup', async (data) => {
            const newData = {...data, technician:null, technician_id:0}
            this.showShop = false
            this.serviceData.push(newData)
            this.lastChangedServiceIndex = null
            this.clearBookingTimes()
            await this.loadTechnicianOptions()
            await this.refreshCalendar()
        })
    },
    beforeDestroy() {
        this.$bus.$off('closePopup')
        this.calendarRequestId += 1
    },
    methods: {

        /** 生成门店当地未来 30 天的预约日期。 */
        buildBookingDates(){
            const parts = new Intl.DateTimeFormat('en-CA',{
                timeZone:this.merchantTimezone,
                year:'numeric',
                month:'2-digit',
                day:'2-digit'
            }).formatToParts(new Date())
            const valueOf = type => {
                const part = parts.find(item=>item.type === type)
                return part ? part.value : ''
            }
            // 使用 UTC 正午承载纯日期，避免跨时区换算落到前一天或后一天。
            const base = new Date(Date.UTC(
                Number(valueOf('year')),
                Number(valueOf('month')) - 1,
                Number(valueOf('day')),
                12
            ))
            const weeks = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
            const months = ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER']
            this.bookingDates = Array.from({length:30},(_,index)=>{
                const date = new Date(base.getTime() + index * 86400000)
                const year = date.getUTCFullYear()
                const month = String(date.getUTCMonth() + 1).padStart(2,'0')
                const day = String(date.getUTCDate()).padStart(2,'0')
                return {
                    date:[year,month,day].join('-'),
                    year,
                    day,
                    week:weeks[date.getUTCDay()],
                    monthName:months[date.getUTCMonth()]
                }
            })
            if(!this.bookingDates.some(item=>item.date === this.selectedDate)){
                this.selectedDate = this.bookingDates[0] ? this.bookingDates[0].date : ''
            }
        },
        /** 按服务顺序构造日历接口所需的技师偏好。 */
        buildServicePayload(){
            return this.serviceData.map(item=>({
                service_id:Number(item.id || item.service_id),
                technician_id:item.technician ? Number(item.technician.id) : Number(item.technician_id || 0)
            }))
        },
        /** 加载当前日期和技师偏好对应的全天可约网格。 */
        async refreshCalendar(){
            // 请求序号用于丢弃快速切换日期或技师后返回的旧响应。
            const requestId = ++this.calendarRequestId
            this.selectedSlot = null
            this.calendarError = ''
            this.calendarClosed = false
            if(!this.selectedDate || this.serviceData.length === 0){
                this.calendarSlots = []
                this.calendarLoading = false
                return
            }
            this.calendarLoading = true
            try{
                const res = await this.$api.getBookingCalendar({
                    app_id:Number(this.appId),
                    date:this.selectedDate,
                    service:JSON.stringify(this.buildServicePayload())
                })
                if(requestId !== this.calendarRequestId) return
                if(res.code !== 1){
                    throw new Error(res.msg || 'Unable to load available times. Please try again.')
                }
                this.calendarSlots = Array.isArray(res.data && res.data.slots) ? res.data.slots : []
                this.calendarClosed = Boolean(res.data && res.data.closed)
            }catch(error){
                if(requestId !== this.calendarRequestId) return
                this.calendarSlots = []
                this.calendarClosed = false
                this.calendarError = (error && error.message) || 'Unable to load available times. Please try again.'
            }finally{
                if(requestId === this.calendarRequestId) this.calendarLoading = false
            }
        },
        /** 切换日期并使旧时间失效。 */
        async handleDateChange(date){
            if(date === this.selectedDate) return
            this.selectedDate = date
            this.clearBookingTimes()
            await this.refreshCalendar()
        },
        /** 使用后端返回的连续服务段设置最终预约时间。 */
        selectCalendarSlot(slot){
            if(!slot || !slot.available || !Array.isArray(slot.services)) return
            this.serviceData = this.serviceData.map((item,index)=>{
                const segment = slot.services[index]
                if(!segment) return item
                return {
                    ...item,
                    start_time:Number(segment.start_time),
                    end_time:Number(segment.end_time),
                    technician_id:item.technician ? Number(item.technician.id) : Number(item.technician_id || 0)
                }
            })
            this.selectedSlot = slot
        },
        /** 将视图滚动回日期选择区域。 */
        handleChooseAnotherDate(){
            const target = this.$refs.dateSection
            if(target && typeof target.scrollIntoView === 'function'){
                target.scrollIntoView({behavior:'smooth',block:'start'})
            }
        },
        /** 全天无可约时间时，仅将最近修改的服务恢复为 Any。 */
        async handleUseAnySpecialist(){
            const index = this.fallbackServiceIndex
            if(index < 0) return
            const service = this.serviceData[index]
            this.$set(service,'technician',null)
            this.$set(service,'technician_id',0)
            this.lastChangedServiceIndex = null
            this.clearBookingTimes()
            await this.refreshCalendar()
        },
        async getSupplierDetail(){
            if(!this.shopSupplierId){
                Notify({ type: 'danger', message: 'No store info available. Cannot add services.' })
                return
            }
            try{
                const params = {
                    app_id: this.appId,
                    shop_supplier_id: this.shopSupplierId
                }
                const res = await this.$api.getSupplierDetail(params)
                if(res.code == 1){
                    this.shopDetail = res.data && res.data.detail || {}
                }else{
                    Notify({ type: 'danger', message: res.msg || 'Failed to load service list' })
                }
            }catch(error){
                console.error(error)
                Notify({ type: 'danger', message: 'Failed to load service list' })
            }
        },

        /**
         * 清空当前服务组合的已选时段。
         */
        clearBookingTimes(){
            this.selectedSlot = null
            this.serviceData = this.serviceData.map(item=>({
                ...item,
                start_time:null,
                end_time:null
            }))
        },
        /**
         * 批量加载每项服务的技师选项。
         */
        async loadTechnicianOptions(){
            const serviceIds = [...new Set(this.serviceData.map(item=>Number(item.id || item.service_id)).filter(Boolean))]
            if(serviceIds.length === 0){
                this.technicianOptions = {}
                return
            }
            try{
                const res = await this.$api.getServiceTechnicians({
                    app_id:Number(this.appId),
                    service_ids:JSON.stringify(serviceIds)
                })
                if(res.code !== 1){
                    throw new Error(res.msg || 'Unable to load available specialists.')
                }
                const options = {}
                for(const item of (res.data && res.data.list) || []){
                    options[Number(item.service_id)] = Array.isArray(item.technicians) ? item.technicians : []
                }
                this.technicianOptions = options
                this.serviceData = this.serviceData.map(item=>{
                    const id = Number(item.id || item.service_id)
                    const selectedId = item.technician ? Number(item.technician.id) : Number(item.technician_id || 0)
                    const exists = (options[id] || []).some(option=>Number(option.id) === selectedId)
                    if(exists) return item
                    return {...item,technician:null,technician_id:0}
                })
            }catch(error){
                this.technicianOptions = {}
                Notify({ type:'danger', message:(error && error.message) || 'Unable to load available specialists.' })
            }
        },
        handleRemove(index){
            Dialog.confirm({
                title:'Delete',
                message:'Are you sure you want to delete this booked service?',
                confirmButtonText:'Confirm',
                cancelButtonText:'Cancel'
            }).then(async ()=>{
                this.serviceData.splice(index,1)
                this.clearBookingTimes()
                if(this.lastChangedServiceIndex === index){
                    this.lastChangedServiceIndex = null
                }else if(this.lastChangedServiceIndex > index){
                    this.lastChangedServiceIndex -= 1
                }
                await this.loadTechnicianOptions()
                await this.refreshCalendar()
            }).catch(()=>{})
        },
        // 选择技师
        handleChoosePeople(index,item){
            this.activeRowIndex = index
            const serviceId = Number(item.id || item.service_id)
            const options = this.technicianOptions[serviceId] || []
            this.peopleList = options.filter(option=>Number(option.id) > 0)
            this.showPeople = true
        },
        /** 更新当前服务的技师偏好并刷新可约时间。 */
        async handlePeople(item){
            const service = this.serviceData[this.activeRowIndex]
            this.$set(service,'technician',item)
            this.$set(service,'technician_id',Number(item.id))
            this.lastChangedServiceIndex = this.activeRowIndex
            this.showPeople = false
            this.clearBookingTimes()
            await this.refreshCalendar()
        },
        /** 将当前服务恢复为 Any Specialist 并刷新可约时间。 */
        async handleAnySpecialist(){
            const index = this.activeRowIndex
            const service = this.serviceData[index]
            this.$set(service,'technician',null)
            this.$set(service,'technician_id',0)
            if(this.lastChangedServiceIndex === index) this.lastChangedServiceIndex = null
            this.showPeople = false
            this.clearBookingTimes()
            await this.refreshCalendar()
        },
        handleOpenShop(){
            this.showShop = true
            if(!this.shopDetail) this.getSupplierDetail()
        },
        /** 格式化服务时长用于页面展示。 */
        formatServiceDuration(item){
            const minutes = Number(item.hour || 0) * 60 + Number(item.minute || 0)
            if(minutes < 60) return minutes + ' min'
            const hours = Math.floor(minutes / 60)
            const rest = minutes % 60
            return rest ? hours + ' hr ' + rest + ' min' : hours + ' hr'
        },
        /** 即时复检服务链并保存支付冲突恢复所需的预约草稿。 */
        async handleGoPay(){
            if(!this.canBook) return
            const data = this.serviceData
            const arr = data.map(item=>({
                service_id:Number(item.id || item.service_id),
                technician_id:item.technician ? Number(item.technician.id) : Number(item.technician_id || 0),
                start_time:Number(item.start_time),
                end_time:Number(item.end_time)
            }))
            try{
                const res = await this.$api.getOderConfirm({service:JSON.stringify(arr)})
                if(res.code !== 1){
                    if(res.data && res.data.error_code === 'SLOT_NO_LONGER_AVAILABLE'){
                        this.clearBookingTimes()
                        await this.refreshCalendar()
                    }
                    Toast.fail(res.msg || 'Booking confirmation failed')
                    return
                }
                sessionStorage.setItem('hwm_booking_calendar_draft',JSON.stringify({
                    serviceData:data,
                    shopSupplierId:this.shopSupplierId,
                    appId:this.appId,
                    selectedDate:this.selectedDate
                }))
                this.$router.push({path:'/payOrder',query:{orderData:JSON.stringify(data)}})
            }catch(error){
                Toast.fail((error && error.message) || 'Booking confirmation failed')
            }
        },

    },
}
</script>
<style lang="scss" scoped>
    .searchData{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F4F4F4;
        border-radius: .25rem;
        padding: 0.5rem;
        box-sizing: border-box;
        margin-top: 1rem;
        font-size: .875rem;
        .shopInfo{
             .address{
                font-size: .75rem;
                color: #666666;
                margin-top: 0.25rem;
            }
        }
        .scoreInfo{
            text-align: right;
        }
    }
    .peopleList{
        margin: 1rem 0;
        .peopleItem{
            display: flex;
            align-items: center;
            font-size: .875rem;
            margin-bottom: 1rem;
            .avtar{
                width: 3rem;
                height: 3rem;
                border-radius: 100%;
                overflow: hidden;
                margin-right: 0.5rem;
            }
            .any-avatar-lg{
                width: 3rem;
                height: 3rem;
                border-radius: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 0.5rem;
                background: #1E3C3E;
                color: #fff;
                font-size: .75rem;
                font-weight: 600;
                flex-shrink: 0;
            }
            .status{
                color: #00C341;
            }
        }
    }
    .bookingBox{
        width: 100%;
        height: 6.5rem;
        margin-top: 1rem;
        .bookingItem{
        width: 100%;
        position: fixed;
        z-index: 20;
        bottom: 0;
        height:6.5rem;
        background: #fff;
        border-top: 1px solid #EEEEEE;
        padding: 0.5rem 1rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        .bookingBtn{
            width: 100%;
            height: 2.75rem;
            border: 0;
            border-radius: .25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #1E3C3E;
            color: #fff;
            font-size: .875rem;

            &:disabled{
                background: #CCCCCC;
            }
        }
    }
    }
    .addBtn{
        width: 100%;
        height: 2rem;
        border-radius: 2.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background: #1E3C3E;
    }
    .serviceList{
        width: 100%;
        // 让第一条Services卡片与顶部栏之间留一点呼吸空间
        padding: .5rem 1rem 0;
        box-sizing: border-box;
        font-size: .875rem;
        .line{
            width: 100%;
            height: 1px;
            background: #CCCCCC;
            margin: 1rem 0;
        }
        .serviceRow{
            width: 100%;
            background: #F4F4F4;
            border-radius: .5rem;
            padding: 1rem;
            box-sizing: border-box;
            margin-bottom: 1rem;
            .serviceBottom{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .chooseServiceBtn{
                    width: auto;
                    height: 2rem;
                    background: #fff;
                    font-size: .75rem;
                    color: #1A3232;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0.5rem;
                    box-sizing: border-box;
                    border-radius: .25rem;
                }
                .serviceInfo{
                    display: flex;
                    align-items: center;
                    .avatar{
                        width: 2rem;
                        height: 2rem;
                        border-radius: 100%;
                        display: block;
                        margin: 0 0.5rem;
                    }
                    .any-avatar{
                        width: 2rem;
                        height: 2rem;
                        border-radius: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 0.5rem;
                        background: #1E3C3E;
                        color: #fff;
                        font-size: .625rem;
                        font-weight: 600;
                        flex-shrink: 0;
                    }
                }
            }
            .serviceItem{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: column;
                .serviceTop{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    .serviceDuration{
                        margin-top: .25rem;
                        color: #666666;
                        font-size: .75rem;
                    }
                    justify-content: space-between;
                }
                .serviceRight{
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    .price{
                        margin: 0.5rem 0;
                    }
                    .close{
                        width: 1.125rem;
                        height: 1.125rem;
                        display: block;
                        cursor: pointer;
                        position: relative;
                        // 关闭按钮向右上微调一点（不影响布局流）
                        top: -1rem;
                        right: -1rem;
                    }
                }
            }
        }
    }
</style>
